import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';
import { I18n } from 'react-redux-i18n';

const AdminNoticeContainer = styled.div`
  border-radius: 4px;
  border: solid 0.5px #adb5bd;
  background-color: rgba(173, 181, 189, 0.2);
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  font-size: 14px;
  letter-spacing: -0.5px;
  color: #adb5bd;
  margin-bottom: 20px;
  padding-left: 15px;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  .adminLock {
    margin-right: 11px;
    font-size: 14px;
  }
`;

const AdminNotice = () => (
  <AdminNoticeContainer>
    <div className="adminLock">
      <Icon icon="lock" />
    </div>
    <p>{I18n.t('adminNotice')}</p>
  </AdminNoticeContainer>
);

export default AdminNotice;
